import { useCallback, useState } from 'react';

/**
 * 확인 체크(#142 재무추가 · #382 기사 페이앱·카드·현금·다수) — 레거시 「확인체크」처럼 맞춰 본 줄을 체크하면 초록으로 칠한다.
 * 레거시도 DB 에 저장하지 않는 화면 표시였다 → 이 브라우저에만 기억한다(다른 사람·다른 PC 엔 안 보인다).
 * 화면마다 키를 따로 둔다(번호 체계가 달라 섞이면 남의 줄이 칠해진다).
 */
export const ROW_CHECKED_CLASS = 'bg-lime-200';

function load(key: string): Set<string> {
  try { return new Set(JSON.parse(localStorage.getItem(key) ?? '[]') as string[]); } catch { return new Set(); }
}
function save(key: string, v: Set<string>) {
  try { localStorage.setItem(key, JSON.stringify([...v].slice(-5000))); } catch { /* 저장 못 해도 화면은 그대로 */ }
}

export function useRowChecks(storageKey: string) {
  const [checked, setChecked] = useState<Set<string>>(() => load(storageKey));
  const toggle = useCallback((id: string | number) => {
    setChecked((cur) => {
      const next = new Set(cur);
      const k = String(id);
      if (next.has(k)) next.delete(k); else next.add(k);
      save(storageKey, next);
      return next;
    });
  }, [storageKey]);
  const isChecked = useCallback((id: string | number) => checked.has(String(id)), [checked]);
  return { checked, isChecked, toggle };
}
